export default "__VITE_ASSET__c605185b__"